import { Typography } from '@forethought-technologies/forethought-elements';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import type { EventMessageComponent } from 'api/types';
import type React from 'react';

interface Props {
  widgetComponent: EventMessageComponent;
}

export const EventMessage: React.FC<Props> = ({ widgetComponent }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        color: theme.palette.colors.grey[600],
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '16px',
      }}
    >
      <Box dir='auto' sx={{ maxWidth: '80%', textAlign: 'center' }}>
        <Typography variant='font12'>
          {widgetComponent.component_fields.message}
        </Typography>
      </Box>
    </Box>
  );
};
